// extracted by css-extract-rspack-plugin
export default {"container":"_b9acd1ec","mobileGrid":"_4059d613","gridItem":"_cb49a9a6","collectionGridItem":"_134599f0"};